import React from "react";

const PortalNews = () => {
  return (
    <div style={{ fontFamily: "sans-serif" }}>
      <div>
        <h5 style={{ textAlign: "center" }}>
          Welcome to the new Prams Portal!
        </h5>
        <h6 style={{ textAlign: "center", fontFamily: "sans-serif" }}>
          This site is currently in development. As the site grows, check back
          here to see new updates.
        </h6>
        <h6 style={{ textAlign: "center", fontFamily: "sans-serif" }}>
          If you are experiencing any issues with the site, please contact the
          Prams team:
        </h6>
        <h6 style={{ textAlign: "center", fontFamily: "sans-serif" }}>
          303-904-6855 Option 1 or email us at
          <a href="mailto:support@pramsplus.com">support@pramsplus.com</a>
        </h6>
      </div>
      <div>
        <h6>
          <b>~07/18/2025~</b>
        </h6>
        <ul>
          <li>Added the Downtime Report page. See below for more details.</li>
          <li>
            Fixed issue with Data View not correctly displaying null data
            points.
          </li>
          <li>
            Fixed issue with hours on and hours down to now show fractional minutes. For example 12:30 will show as 12.5.
          </li>
        </ul>
          The Downtime Report Page provides a summary for the following:
          <ul>
            <li>Downtime by Site</li>
            <li>Lost Production by Site</li>
            <li>Downtime Percentage by Down-Code</li>
            <li>Summary Table</li>
          </ul>
      </div>
      <div>
        <h6>
          <b>~06/18/2025~</b>
        </h6>
        The release of the new Prams Portal is now live! Currently the new site
        contains the following pages that can be accessed via the menu at the
        top left of the screen:
        <ul>
          <li>
            <b>Home Screen</b>
          </li>
          <ul>
            <li>
              The main landing page that will display the latest news by default
              in a large card to the left side of the screen. The right side
              will contain small cards that can be used to display Oil, Gas, or
              Water for a quick snapshot of the current production.
            </li>
            <li>
              To get started with the small cards click the + sign to set up a
              new card. Cards can be added and taken away as needed. To refresh
              at any time, click the refresh button to the left of the + button.
            </li>
            <li>
              Large and small cards will gain new features as time goes on.
            </li>
          </ul>
          <li>
            <b>Data View</b>
          </li>
          <ul>
            <li>
              This page will allow you to view many data points for an
              individual site or multiple sites in a group that was created in
              Group Maintenance.
            </li>
            <li>
              Contains an interactive chart and table that can be exported to
              excel.
            </li>
          </ul>
          <li>
            <b>Drill Down</b>
          </li>
          <ul>
            <li>
              Start by selecting a date and a group to see a cascading list of
              dropdowns that display Oil, Gas, and Water totals along with
              averages and Remarks.
            </li>
          </ul>
          <li>
            <b>Reports</b>
          </li>
          <ul>
            <li>
              This page allows you to run reports with different variants and
              export them to either Excel or PDF
            </li>
            <li>
              If you like a report, make sure to save a template so it can be
              recalled for the future.
            </li>
          </ul>
          <li>
            <b>Group Maintenance</b>
          </li>
          <ul>
            <li>
              With this page you can create groups of sites that can be used in
              Data View and Drill Down. Other future pages will also utilize
              groups.
            </li>
            <li>
              Groups can be set up the following ways: Static - Select your own
              sites, Dynamic - Select a filter(s) to automatically populate the
              group with sites that match the criteria, and Hierarchy - Select
              from a list of available fields to populate a list of sites,
              excluding source sites (Battery, Central Disposal, etc.) and
              Injection sites.
            </li>
          </ul>
        </ul>
      </div>
    </div>
  );
};

export default PortalNews;
